/**
 * Header 컴포넌트
 *
 * 모든 화면 상단에 표시되는 공통 헤더
 * - 로고 표시
 * - 설정 아이콘 (설정 화면 진입)
 * - 사용자 프로필 및 로그아웃
 */

import { Link } from 'react-router-dom'
import { useAuth } from '@/core/auth/useAuth'
import { isMockMode } from '@/core/config/env'
import { WorkspaceSelector } from '@/core/workspace/components/WorkspaceSelector'

export function Header() {
  const { user } = useAuth()

  return (
    <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 py-3">
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        {/* 로고 + 워크스페이스 선택 */}
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100">ourWallet</h1>
          {isMockMode() && (
            <span className="text-xs bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 px-2 py-1 rounded">
              Mock
            </span>
          )}
          {/* 워크스페이스 선택 (Mock 모드가 아닐 때만 표시) */}
          {!isMockMode() && user && <WorkspaceSelector />}
        </div>

        {/* 우측 영역: 설정 + 사용자 프로필 */}
        {user && (
          <div className="flex items-center gap-4">
            {/* 설정 아이콘 */}
            <Link
              to="/settings"
              className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 rounded"
              title="설정"
              aria-label="설정"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </Link>

            {/* 사용자 프로필 */}
            <div className="flex items-center gap-3">
              {user.picture && (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="w-8 h-8 rounded-full"
                />
              )}
              <span className="text-sm text-gray-700 dark:text-gray-200">{user.name}</span>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}
